import React from 'react';
import PropTypes from 'prop-types';
import Paragraph from './Paragraph';
import './Separator.scss';

const Separator = (props) => {
  const {
    text,
    dark,
    secondary,
  } = props;

  const style = {
    dark,
    secondary,
  };

  if (style.dark) {
    style.secondary = false;
  }

  return (
    <div className="separator">
      <div>
        <Paragraph {...style}>
          <span className="separator__text">
            {text}
          </span>
        </Paragraph>
      </div>
    </div>
  );
};

Separator.propTypes = {
  text: PropTypes.string.isRequired,
  secondary: PropTypes.bool,
  dark: PropTypes.bool,
};

Separator.defaultProps = {
  secondary: true,
  dark: false,
};

export default Separator;
